import { IS_ADDRESS_REGISTERED } from '../actions/physical-product';

export const isAddressRegisteredReducer = (state = false, action) => {
  switch (action.type) {
    case IS_ADDRESS_REGISTERED:
      return action.payload;
  }
  return state;
};
